import React, { useContext, useState, useEffect } from 'react';
import axios from 'axios';
import RuntimeValuesProvider, { RuntimeValuesContext } from '../../context/RuntimeValuesContext';

const config = require('../../config/config.json');

interface RowData {
    // Define the structure of your table data
    productBrand: string;
    productType: string;
    name: string;
    descriptionShort: string;
    descriptionLarge: string;
    price: number;
    priceCurrency: number;
    // Add more properties as needed
  }

  const DataTableProducts = () => {
    const [data, setData] = useState<RowData[]>([]);

    const {runtimeValues, setRuntimeValues} = useContext(RuntimeValuesContext);
  
    useEffect(() => {
      const fetchData = async () => {
        try {
            console.log("runtimeValues.currency: ", runtimeValues.currency);
          const response = await axios.get(config.backend.url + '/api/products/' + runtimeValues.currency); // Replace with your backend API URL
          setData(response.data);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      };
  
      fetchData();
    }, [runtimeValues.currency]);

    let formatterUSD = new Intl.NumberFormat('en-US', 
        { style: 'currency',
            currency: 'USD'
        });
    let formatter = new Intl.NumberFormat('en-US', 
        { style: 'currency',
            currency: 'USD'
        });
      switch(runtimeValues.currency){
        case 'COP':{
            formatter = new Intl.NumberFormat('es-CO', 
                { style: 'currency',
                    currency: 'COP'
                });
        }break;
      case 'CLP':{
        formatter = new Intl.NumberFormat('es-CL', 
            { style: 'currency',
                currency: 'CLP'
            });
    }break;
      case 'PEN':{
        formatter = new Intl.NumberFormat('es-PE', 
            { style: 'currency',
                currency: 'PEN'
            });
    }break;
      case 'PYG':{
        formatter = new Intl.NumberFormat('es-PY', 
            { style: 'currency',
                currency: 'PYG'
            });
    }break;
       case'UYU':{
        formatter = new Intl.NumberFormat('es-UY', 
            { style: 'currency',
                currency: 'UYU'
            });
    }break;

        default:{
            formatter = new Intl.NumberFormat('en-US', 
                { style: 'currency',
                    currency: 'USD'
                });
        }
      }

      return (
        <table>
          <thead>
            <tr>
              <th className='table-header'>TYPE</th>
              <th className='table-header'>BRAND</th>
              <th className='table-header'>NAME</th>
              <th className='table-header'>SHORT DESC</th>
              <th className='table-header'>LARGE DESC</th>
              <th className='table-header'>PRICE USD</th>
              <th className='table-header'>PRICE {runtimeValues.currency}</th>
              {/* Add more headers as needed */}
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={index}>
                <td className='table-row'>{row.productBrand}</td>
                <td className='table-row'>{row.productType}</td>
                <td className='table-row'>{row.name}</td>
                <td className='table-row'>{row.descriptionShort}</td>
                <td className='table-row'>{row.descriptionLarge}</td>
                <td className='table-row'>{formatterUSD.format(row.price)}</td>
                <td className='table-row'>{formatter.format(row.priceCurrency)}</td>
                {/* Add more cells as needed */}
              </tr>
            ))}
          </tbody>
        </table>
      );
    };
    
    export default DataTableProducts;